module.exports = __webpack_public_path__ + "static/media/amusement(5).ff70e8ff.PNG";